import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { VerificacionService } from "src/app/comun/services/verificacion.service";
import { PasswordService } from "src/app/microempresario/services/password.service";
import { ParametrosService } from "src/app/services/parametros.service";
import { SweetAlertService } from "src/app/services/sweet-alert.service";
import {
  AuthFlowOrigen,
  getAuthFlowBgDesktop,
  getAuthFlowBgMobile,
  setAuthFlowOrigen,
} from "src/app/core/auth-flow-origen.storage";
import { PASSWORD_COMPLEXITY_PATTERN } from "src/app/shared/utils/validation.constants";

@Component({
  selector: 'app-recodar-contrasena',
  templateUrl: './recodar-contrasena.component.html',
  styleUrls: ['./recordar-contrasena.component.scss'],
  standalone: false
})
export class RecodardContrasenaComponent implements OnInit {
  regPassword = PASSWORD_COMPLEXITY_PATTERN;  isVisible = false;
  isVisibleConfirm = false;
  token = '';
  username = '';
  email = '';
  /** Sin token = activación IF; con token = recordar (micro o IF) → imagen micro. */
  isActivacion = false;
  titulo = 'Asignar nueva contraseña';
  authOrigen: AuthFlowOrigen = 'micro';
  bgDesktop = getAuthFlowBgDesktop('micro');
  bgMobile = getAuthFlowBgMobile('micro');

  constructor(
    private _password: PasswordService,
    private _parametro: ParametrosService,
    private _verificacion: VerificacionService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private _sweetAlert: SweetAlertService
  ) {
    this.token = this.route.snapshot.params.token;
    this._verificacion.saveToken(this.token);
    this.isActivacion = !this.token;
    if (this.isActivacion) {
      this.titulo = 'Activa tu usuario';
      this.authOrigen = 'if';
      setAuthFlowOrigen('if');
    } else {
      this.titulo = 'Asignar nueva contraseña';
      this.authOrigen = 'micro';
      setAuthFlowOrigen('micro');
    }
    this.bgDesktop = getAuthFlowBgDesktop(this.authOrigen);
    this.bgMobile = getAuthFlowBgMobile(this.authOrigen);
  }

  public recodarForm = this.formBuilder.group(
    {
      contraseña: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.regPassword),
        ],
      ],
      confirmarContrasena: ['', Validators.required],
    },
    {
      validator: this._password.matchPassword(
        'contraseña',
        'confirmarContrasena'
      ),
    }
  );

  ngOnInit(): void {
    if (this.token) {
      this.getDataToken();
    } else {
      try {
        const raw = localStorage.getItem('activate');
        if (!raw) {
          this._sweetAlert
            .errorModal('Error!', true, 'No hay datos de activación. Vuelve a buscar tu usuario.')
            .then(() => this.router.navigateByUrl('/activar-usuario'));
          return;
        }
        const userData = JSON.parse(raw);
        this.username = userData.user;
        this.email = userData.email;
      } catch {
        this.router.navigateByUrl('/activar-usuario');
      }
    }
  }

  getDataToken() {
    this._parametro.getDataFromToken(this.token).subscribe((data: any) => {
      if (data.exitoso) {
        this.username = data.usuario;
        this._verificacion.saveTokenNeo(data.tokenNeo);
      } else {
        this._sweetAlert.errorModal("Error!", true, data.mensaje);
      }
    });
  }

  sendOtp() {
    this._parametro.sendOtp(this.email).subscribe((data: any) => {
      if (data.exitoso == "true" || data.exitoso == true) {
        this._sweetAlert.successModal("Éxito!", false, 'Código enviado a ' + this.email);
        var userData: any = {
          token: '',
          password: '',
          isRecordar: false,
          isInter: false,
          email: '',
        };
        if (JSON.parse(localStorage.getItem('activate'))) {
          userData = JSON.parse(localStorage.getItem('activate'));
        }
        userData.token = data.token;
        userData.password = this.recodarForm.get('contraseña').value;
        userData.email = this.email;
        if (this.token) {
          userData.isRecordar = true;
        } else {
          userData.isInter = true;
        }
        if (!this.token) {
          localStorage.setItem('activate', JSON.stringify(userData));
        }
        this._verificacion.saveParameters(userData);
        this.router.navigateByUrl('/verificacion');
      } else {
        this._sweetAlert.errorModal("Error!", true, 'Se ha presentado un error general en el servicio');
      }
    });
  }

  sendOtpRecordarContrasena() {
    this._parametro.validacionRecordarContrasena(
      this.token,
      this.recodarForm.get('contraseña').value).then((response: any) => {
      if (response.exitoso == true) {
        this._sweetAlert.successModal('La nueva contraseña ha sido asignada al usuario');
        this.router.navigateByUrl('/login');
      } else {
        this._sweetAlert.errorModal("Error!", true, response.mensajeError);
        return;
      }
    });
  }

  back() {
    if (this.isActivacion) {
      this.router.navigateByUrl('/activar-usuario');
    } else {
      this.router.navigateByUrl('/recordar');
    }
  }

  showPassword(item: string) {
    if (item !== '') {
      this.isVisible = !this.isVisible;
    } else {
      this.isVisibleConfirm = !this.isVisibleConfirm;
    }
  }

  validateField(key: string) {
    return (
      (this.recodarForm.get(key).dirty || this.recodarForm.get(key)?.touched) &&
      this.recodarForm.get(key)?.invalid
    );
  }
}
